import * as React from "react"

import Layout from "../../components/layout"
import Header from "../../components/header"
import Seo from "../../components/seo"

import DetailItem from "../../components/DetailItem"
import HomeItem from "../../components/HomeItem"

import JSONData from "../../assets/jsons/a-la-carte.json";
import MenuData from "../../assets/jsons/lunch.json";


const ALaCarte = () => (
  <Layout>
    <Seo title={JSONData.title} />
    <Header siteTitle={JSONData.title} withBack />
    <h2 className="detailItem-title">{JSONData.title}</h2>
    <p className="detailItem-description">{JSONData.description}</p>
    <div className="detailItem-wrap">
      {JSONData.items.map((item, index) => {
        return <DetailItem key={'a' + item.id} item={item} />
      })}
    </div>
    <div className="otherMenus">
      <h2 className="otherMenus-title">Other menus</h2>
      <ul className="homeItem-wrap">
        {MenuData.menus.map((item, index) => {
          if(item.id !== JSONData.id) { 
            return <HomeItem key={'o' + item.id} item={item} />
          }
          return <div key={'o' + item.id}></div>
        })}
      </ul>
    </div>
  </Layout>
)

export default ALaCarte
